// Module
var code = "<div class=\"md-checkbox\"> <input type=\"checkbox\" id=\"expand-collapse\" class=\"md-check\"> <label for=\"expand-collapse\" class=\"col-md-offset-1 col-md-11\"> <span class=\"inc\"></span> <span class=\"check\"></span> <span class=\"box\"></span> Expand/Collapse </label> </div>";
// Exports
export default code;